import axios from "axios";
import { VerifyOtpPayload, LoginPayload } from "../types/auth";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export const registerUser = (formData: FormData) =>
  axios.post(`${API}/auth/register`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const verifyOtp = (data: { email: string; code: string }) => {
  return axios.post(
    "https://api.gelwelpartners.com/auth/verify-otp",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const loginUser = (data: { email: string; password: string }) => {
  const form = new FormData();
  form.append("email", data.email);
  form.append("password", data.password);

  return axios.post(`${API}/auth/login`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const adminloginUser = (data: { email: string; password: string }) => {
  const form = new FormData();
  form.append("email", data.email);
  form.append("password", data.password);

  return axios.post(`${API}/admin/login`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

